// Retrieve the config.ini value for a public configuration from BE1
// In BE2 the config is passed custom to the window.ELSTR.applicationData.config object
// ex: config(supportedLanguages) will return an array of the supported languages
// returns null when the requested key doesn't exist
export function config(key: string): any {
  if (ElstrConfig._config[key]) {
    return ElstrConfig._config[key];
  }

  return null;
}

// Stores the initial config delivered at the app initialization
// Only the public values from the config.ini are promoted to the frontend with BE1
export default class ElstrConfig {
  static _config: any = window?.ELSTR?.applicationData?.config
    ? window.ELSTR.applicationData.config
    : {};
}
